
import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function consoleGenderList(
    console_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/console/${console_id}/gender/list${queryString}`
    );
}

export async function consoleGenderGet(
    item_id: string
) {
    return await clientAxios.get(
        `admin/console/gender/${item_id}/show`
    );
}

export async function consoleGenderCreate(
    console_id: string,
    payload: Partial<any>
) {
    return await clientAxios.post(
        `admin/console/${console_id}/gender/create`,
        payload
    );
}

export async function consoleGenderPatch(
    item_id: string,
    payload: Partial<any>
) {
    return await clientAxios.patch(
        `admin/console/gender/${item_id}/patch`,
        { payload }
    );
}

export async function consoleGenderDel(
    item_id: string,
) {
    return await clientAxios.del(
        `admin/console/gender/${item_id}/delete`,
    );
}
